<template>
  <div id="header">
    <b-navbar toggleable="lg" type="gradiente" class="backgraund" :style="cssVars" >

      <b-navbar-toggle  v-model="aberto" class="btn-celular" aria-haspopup="true" aria-expanded="true" target="nav-collapse" ></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>

        <b-navbar-nav>
          <div>
            <!-- <b-img center :src="require('@/assets/logo/' + logo)" alt="TECHNO PLUS" -->
            <b-img center :src="logo" alt="TECHNO PLUS"
            style="cursor: pointer"
            @click="toGestaoCandidatos"></b-img>
          </div>
        </b-navbar-nav>

        <!-- Itens de navegação alinhados à direita -->
        <b-navbar-nav class="user-celular ml-auto">

          <template :style="cssVars">
            <em class="nome-usuario"
            style="cursor: pointer; padding: 7px"
            @click="toGestaoCandidatos" >Gerenciar candidatos •</em>
          </template>


          <template :style="cssVars">
            <em class="nome-usuario"
            style="cursor: pointer; padding: 7px"
            @click="toDashboard"  v-if="acessoDashboard">Analisar Dados •</em>
          </template>

          <!-- DROPDOWN DE EMPRESAS (só aparece se tiver mais de 1) -->
          <b-nav-item-dropdown
            v-if="empresasDisponiveis.length > 1"
            right
            :style="cssTitulo"
            class="mr-2">

            <template #button-content :style="cssVars">
              <em class="nome-usuario">{{ empresaNome }}</em>
            </template>

            <b-dropdown-item
              v-for="emp in empresasDisponiveis"
              :key="emp.value"
              @click="trocarEmpresa(emp.value)"
              :active="emp.value === empresaSelecionadaId">
              {{ emp.text }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown  right :style="cssTitulo">

            <template #button-content :style="cssVars">
              <em class="nome-usuario">{{ usuario }}</em>
            </template>

            <b-dropdown-item @click="toPainelAdmin" v-if="acessoPainelAdmin">Painel Administrativo</b-dropdown-item>

            <b-dropdown-item @click="toPainelTechnoplus" v-if="acessoPainelTechnoplus">Painel Technoplus</b-dropdown-item>

            <b-dropdown-item @click="toAlterarSenha">Alterar Senha</b-dropdown-item>

            <b-dropdown-item @click="toMostrarAvisos">Avisos</b-dropdown-item>

            <!-- <b-dropdown-item href="https://highfalutin-pencil-8e6.notion.site/O-que-h-de-novo-974bc4edebf045b2b3d02b0119810207" target="_blank"
            >Detalhes da versão</b-dropdown-item> -->

            <b-dropdown-item href="https://technoplusltda.zohodesk.com/portal/pt-br/kb/articles/contratei-oque-ha-de-novo" target="_blank"
            >Ajuda</b-dropdown-item>

            
            <b-dropdown-item @click="logOut">Sair</b-dropdown-item>
       

          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>


    <!-- MODAL AVISOS -->
    <div>
      <b-modal ref="modal-avisos" hide-footer title="Avisos!" size="lg">

        <ModalAvisos :setAvisosTodos="setAvisosTodos">
        </ModalAvisos> 

      </b-modal>
    </div>
    <!-- MODAL AVISOS FIM -->



  </div>

</template>

<script>
import firebase from "../services/firebaseConnection";
import api from "../services/api";
import validaCredencial from "../../src/pages/web_cliente/utils";
import ModalAvisos from '../../src/pages/web_cliente/painelAdmin/modal/ModalAvisos';

export default {
  name: "Header",
  components: { 
    ModalAvisos
   },

  data() {
    return {

      bgColor: '',
      fontColor: '',
      logo: '',
      aberto: true,
      usuario: "",
      acessoDashboard: false,
      acessoPainelAdmin: false,
      acessoPainelTechnoplus: false,

      setAvisosTodos: false,

      // Dados para troca de empresa
      empresasDisponiveis: [],
      empresaSelecionadaId: null,
      empresaNome: ''

    };
  },

  
  methods: {

    msg(titulo, texto, cor, time = 10000) {
      this.toastCount++;
      this.$bvToast.toast(texto, {
        title: titulo,
        variant: cor,
        solid: true,
        autoHideDelay: time,
        appendToast: true,
      });
    },

    async toPainelAdmin() {

      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(100)
      if (acessoPermitido == 'fail') {
        this.msg("ATENÇÃO", "Você não possui permissão para continuar.", "warning", 3000);
        return
      }
      //------------------------------------------------------------------


      this.$router.push("/painelAdmin")
    },

    async toPainelTechnoplus() {

      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(999)
      if (acessoPermitido == 'fail') {
        this.msg("ATENÇÃO", "Você não possui permissão para continuar.", "warning", 3000);
        return
      }
      //------------------------------------------------------------------


      this.$router.push("/cobranca")
    },

    toGestaoCandidatos() {
      this.$router.push("/candidatos")
    },

    async toDashboard() {

      // Valida credenciais
      //------------------------------------------------------------------
      const acessoPermitido = await validaCredencial(31)
      if (acessoPermitido == 'fail') {
        this.msg("ATENÇÃO", "Você não possui permissão para continuar.", "warning", 3000);
        return
      }
      //------------------------------------------------------------------


      this.$router.push("/dashboard")
    },

    toAlterarSenha() {
      this.$router.push("/alterar-senha")
    },

    async logOut() {
      const confirm = window.confirm("Você realmente deseja sair?");

      if (confirm) {
        // Clear Vuex state (automatically clears localStorage and auth headers)
        this.$store.commit('auth/setUser', null)
        this.$store.commit('setEmpresaSelecionada', null)

        // Clear legacy Firebase session
        await firebase.auth().signOut()

        // Clear legacy localStorage keys
        localStorage.removeItem("usuario")
        localStorage.removeItem("emailUsuario")

        // Redirect to login
        this.$router.push("/login")
      }
    },


    getAvisos() {

      this.setAvisosTodos = false
      
      api.get('web-cliente/painel-admin/avisos')
      .then((res) => {

        this.avisos = res.data

        if (this.avisos.length > 0) 
        this.$refs["modal-avisos"].show();
     
      })
      .catch((err) => {
        this.msgNotification(err.response.data, 'error', 5000)
      });
    },


    toMostrarAvisos() {

      this.setAvisosTodos = true
      this.$refs["modal-avisos"].show()
    },

    async trocarEmpresa(idEmpresa) {

      // Evita trocar para a mesma empresa
      if (idEmpresa === this.empresaSelecionadaId) return

      // Modal de confirmação elegante do Bootstrap Vue
      const confirmado = await this.$bvModal.msgBoxConfirm('Deseja trocar de empresa?', {
        title: 'Confirmar',
        okVariant: 'danger',
        okTitle: 'Sim, trocar',
        cancelTitle: 'Cancelar',
        centered: true,
        hideHeaderClose: false
      })

      if (!confirmado) return

      try {

        // Loading
        this.$store.commit('auth/setLoading', true)

        // Chamar API para trocar empresa
        const res = await api.post('web-cliente/trocar-empresa', { idEmpresa })

        // Atualizar store (persiste automaticamente no localStorage)
        this.$store.commit('setEmpresaSelecionada', res.data)

        // Páginas com dados específicos de candidato - redirecionar para evitar vazamento
        const paginasSensiveis = ['/candidato/consultar', '/candidato/avaliar']

        if (paginasSensiveis.includes(this.$route.path)) {
          // Redireciona para página segura
          window.location.href = '/candidatos'
        } else {
          // Reload na página atual
          window.location.reload()
        }

      } catch (err) {
        console.error('Erro ao trocar empresa:', err)
        this.msg("ATENÇÃO", err.response?.data || "Erro ao trocar empresa", "danger")
        this.$store.commit('auth/setLoading', false)
      }
    }

  },

  computed: {

    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--height": this.height + "px",
        "--font-color": this.fontColor,
        
      };
    },

    cssTitulo() {
      return {
        "--color": this.color,
        "--height": this.height + "px",
       
      };
    }
  },

  async mounted() {

    const empresa = this.$store.state.empresaSelecionada
    const user = this.$store.state.auth.user

    // NOTE: App.vue now guarantees store is hydrated before this component mounts
    // Router guard ensures authentication, so data will always be available here
    this.bgColor = empresa.cor;
    this.fontColor = empresa.corFonte;
    this.logo = empresa.logoPath;
    this.color = empresa.titulo;
    this.usuario = user.nome;

    // Carregar lista de empresas disponíveis para troca
    if (user && user.empresas) {
      this.empresasDisponiveis = user.empresas
      this.empresaSelecionadaId = empresa.id
      this.empresaNome = empresa.nomeEmpresa
    }

    // Valida credenciais
    //------------------------------------------------------------------
    var acessoPermitido = await validaCredencial(31)
    acessoPermitido == 'fail' ? this.acessoDashboard = false : this.acessoDashboard = true

    acessoPermitido = await validaCredencial(100)
    acessoPermitido == 'fail' ? this.acessoPainelAdmin = false : this.acessoPainelAdmin = true

    acessoPermitido = await validaCredencial(999)
    acessoPermitido == 'fail' ? this.acessoPainelTechnoplus = false : this.acessoPainelTechnoplus = true
    //------------------------------------------------------------------


    // alert('oioio')
    // this.$refs["modal-avisos"].show();
    this.getAvisos()

  },
};
</script>



<style scoped>

.dropdown-toggle {
    white-space: nowrap;
    color: rgb(0, 0, 0);
}

.user-celular {
  color: #000;
}

[data-v-61dd7a3d], [data-v-61dd7a3d]::before, [data-v-61dd7a3d]::after {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.2;
  box-sizing: border-box;
  color: var(--color);
}

@media screen and (max-width: 480px) {
    [data-v-61dd7a3d], [data-v-61dd7a3d]::before, [data-v-61dd7a3d]::after {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.2;
      box-sizing: border-box;
      color: var(--color);
    }
}

*, ::before, ::after {
    box-sizing: border-box;
     color: #000;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(197 45 186 / 25%) !important;
}

.backgraund {
  background-color: var(--bg-color);
  z-index: 8;
}

.btn-celular {
    display: none;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    background-color: #fff;
    border-radius: 50%;
}

@media screen and (max-width: 991px) {
    .btn-celular {
        display: inline-block;
    }
}

img {
  padding-top: 7px;
  padding-bottom: 7px;
  height: 70px;
}

.nome-usuario {
  color: var(--font-color);
}

</style>


